export class AWSPollyFile {
    voice: any;
    message: string;
    file: any;
    filePath: string;
    constructor() {
        this.voice = {
            gender: '',
            id: '',
            languageCode: '',
            languageName: '',
            voiceId: '',
            engine: ''
        };
        this.message = '';
        this.filePath = '';
    }
}
